import { lazy } from 'react';
import { RouteObject } from 'react-router';

// project import
import Loadable from 'components/Loadable';
import PreviewContextProvider from '../contexts/PreviewContext';
import Pages from '../pages/cms/Pages';

// render pages
const CmsFiles = Loadable(lazy(() => import('pages/cms/Files')));
// @ts-ignore
const CmsPages = Loadable(Pages);
const CmsCreatePage = Loadable(lazy(() => import('pages/cms/CreatePage')));
const CmsEditPage = Loadable(lazy(() => import('pages/cms/EditPage')));

const PreviewCreateContainer = () => (
    <PreviewContextProvider>
        <CmsCreatePage />
    </PreviewContextProvider>
);

const PreviewEditContainer = () => (
    <PreviewContextProvider>
        <CmsEditPage />
    </PreviewContextProvider>
);

// ==============================|| CMS SUB ROUTING ||============================== //

const CmsRoutes: RouteObject = {
    path: 'cms',
    children: [
        {
            path: 'files',
            element: <CmsFiles />,
        },
        {
            path: 'pages',
            element: <CmsPages />,
        },
        {
            path: 'pages/index/new/:locale',
            element: <PreviewCreateContainer />,
        },
        {
            path: 'pages/:id/new/:locale',
            element: <PreviewCreateContainer />,
        },
        {
            path: 'pages/:id/edit',
            element: <PreviewEditContainer />,
        },
        {
            path: 'pages/:id/edit/:locale',
            element: <PreviewEditContainer />,
        },
    ],
};
export default CmsRoutes;
